/* src/app/modules/home/components/home-page/home-page.component.scss */
.tabpanel {
  padding: 1rem 0;
}
.greet-container {
  padding: 0 0 0.625rem 0;
  margin: 0;
}
.greet-container.greeting__title {
  font-size: 2.3em;
  line-height: 1em;
  font-weight: var(--ods-font-weight-normal);
}
.greet-container p {
  margin: 0;
}
.greet-container.greet-container-covid p {
  flex: 1;
}
.tablist {
  display: flex;
  justify-content: flex-end;
  margin: 0;
  padding: 0 0 0 1rem;
  list-style: none;
  border-bottom: 0.063rem solid var(--neutral-20);
  overflow: visible;
}
.tablist li {
  flex: 0 0 8rem;
  border-bottom: 2px solid var(--ods-color-gray-20);
}
.tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 2rem;
  min-width: 0;
  text-decoration: none;
  color: var(--ods-color-gray-50);
  font-weight: var(--ods-font-weight-semibold);
  border-bottom: 0.125rem solid transparent;
  cursor: pointer;
  position: relative;
}
.tab[aria-selected=true] {
  border-bottom-color: var(--brand-50, #7c1f74);
  color: var(--neutral-100);
  bottom: -1px;
}
.tab[aria-selected=true]::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: var(--brand-50, #7c1f74);
  z-index: 2;
}
.tab:hover {
  text-decoration: none;
}
.tab:focus-visible {
  outline: 0.125rem solid var(--focus, #7c1f74);
  outline-offset: 0.125rem;
}
.covid-hero {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}
.greet-container.greet-container-covid {
  display: flex;
  align-items: center;
}
.covid-hero .greeting__title,
.covid-hero .greeting__link,
.covid-hero p {
  margin: 0;
}
.covid-hero .greeting__title {
  margin: 0;
  flex: 0 0 auto;
  font-size: 2.3rem;
  line-height: 1.05;
  font-weight: var(--ods-font-weight-normal);
}
.covid-hero .greeting__link {
  margin: 0;
  font-size: 1rem;
  line-height: 1.25;
}
/*# sourceMappingURL=home-page.component.css.map */
